import { envConfig } from "../envConfig";
import { clearToken } from "./sessionToken";

export function getAppOrigin() {
  return window.location.origin;
}

export function getSSOTicket() {
  return Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  )["sso_ticket"];
}

export function goLogout() {
  clearToken();
  window.location.href = `${envConfig.logout}?app=${encodeURIComponent(
    getAppUrl()
  )}`;
}

export function getAppUrl() {
  const { origin, pathname, hash } = document.location;
  return origin + pathname + hash;
}
